import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './styles.scss';

export function TinyBar({ className }) {
  return <div className={classnames('feed-skeleton-bar feed-skeleton-bar--tiny', className)} />;
}

TinyBar.propTypes = {
  className: PropTypes.string,
};

export function SmallBar({ className }) {
  return <div className={classnames('feed-skeleton-bar feed-skeleton-bar--small', className)} />;
}

SmallBar.propTypes = {
  className: PropTypes.string,
};

export function MediumBar({ className }) {
  return <div className={classnames('feed-skeleton-bar feed-skeleton-bar--medium', className)} />;
}

MediumBar.propTypes = {
  className: PropTypes.string,
};

export function BigBar({ className }) {
  return <div className={classnames('feed-skeleton-bar feed-skeleton-bar--big', className)} />;
}

BigBar.propTypes = {
  className: PropTypes.string,
};

export function FullBar({ className }) {
  return <div className={classnames('feed-skeleton-bar feed-skeleton-bar--full', className)} />;
}

FullBar.propTypes = {
  className: PropTypes.string,
};
